<div>

    <header 
        class="accent" 
        fxLayout="row" 
        fxLayoutAlign="space-between center"
    >
        <div class="title">Extrato Investimentos</div>
        <div 
            class="more secondary-text" 
            *ngIf="!isComplete"
            (click)="handleExtractFullClient()"
        >
            <span>Veja mais...</span>
        </div>
    </header>
    
    <div>
        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingIndicator"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"                       
            [footerHeight]="50" 
            [rowHeight]="'auto'" 
            [rows]='rows'
            [limit]="params.per_page"
            (sort)="onSort($event)"
        >       

            <ngx-datatable-column 
                name="Data" 
                prop="data_compra" 
                [sortable]="false" 
                [width]="100"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-data_compra="value" 
                    ngx-datatable-cell-template
                >
                    {{ data_compra | date:'dd/MM/yyyy'}}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column 
                name="Mercado" 
                prop="mercado" 
                [sortable]="false"
                *ngIf="isComplete"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-row="row" 
                    ngx-datatable-cell-template
                >
                    {{ row.mercado.nome }}
                </ng-template>
            </ngx-datatable-column>


            <ngx-datatable-column 
                name="Descrição" 
                prop="movimentacao" 
                [sortable]="false"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-row="row" 
                    ngx-datatable-cell-template
                >
                    <span>
                        {{ row.movimentacao }}
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column 
                name="Operação" 
                prop="lancamento" 
                [sortable]="false"
                *ngIf="isComplete"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-row="row" 
                    ngx-datatable-cell-template
                >
                    {{ row.lancamento.nome }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column 
                name="Valor (R$)" 
                prop="vlr_bruto" 
                [sortable]="false"
            >
                <ng-template 
                    let-rowIndex="rowIndex" 
                    let-row="row" 
                    ngx-datatable-cell-template
                >
                    <span                         
                        [ngClass]="{
                            'negativo': row.vlr_bruto < 0, 
                            'positivo': row.vlr_bruto > 0
                        }"
                    >
                        R$ {{ (row.vlr_liquido > 0 ? row.vlr_liquido : row.vlr_bruto) | number : '1.2-2' }}
                    </span>
                </ng-template>
            </ngx-datatable-column>

        </ngx-datatable>

        <div *ngIf="isComplete">
            <mat-paginator 
                #paginator 
                [length]="length"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>
    </div> 

</div>


